import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router';
import { format } from 'date-fns';
import { BaseLineChart, generateTicks } from './BaseLineChart';
function CodeCoverageChartBase({ activeBranch, baseLink, codeCoverage, history }) {
    const { commitList } = activeBranch;
    const coveredCommits = codeCoverage.commits;
    const handleClick = (chartElement) => {
        if (chartElement.activeLabel) {
            history.push(`${baseLink}/commits/${commitList.commits.find((commit) => commit.datetime === chartElement.activeLabel)?.hash}`);
        }
    };
    const data = commitList.commits.map((commit) => ({
        dateTime: format(new Date(Number(commit.datetime)), 'MM/dd HH:mm'),
        message: commit.message,
        hash: commit.hash,
        id: commit.id,
        chartLines: {
            branches: coveredCommits[commit.id]?.digest.getBranches() || void 0,
            branchesThreshold: commit.options?.thresholds?.coveredBranches,
            functions: coveredCommits[commit.id]?.digest.getFunctions() || void 0,
            functionsThreshold: commit.options?.thresholds?.coveredFunctions,
            lines: coveredCommits[commit.id]?.digest.getLines() || void 0,
            linesThreshold: commit.options?.thresholds?.coveredLines,
        },
    })).reverse();
    return (_jsx(BaseLineChart, { height: 260, chartData: data, yTicks: generateTicks(0, 100, 10), chartType: 'codeCoverage', tooltipData: codeCoverage.commits, handleClick: handleClick }));
}
export const CodeCoverageChart = withRouter(CodeCoverageChartBase);
